import type { FC } from 'react';

import { FormInput } from '@catalyze/ui';

import { FormLine } from '../FormLine';
import { ProfileToggle } from '../ProfileToggle';

export const ProfileDetails: FC = () => (
    <>
        <FormLine>
            <FormInput id="firstName" label="First name" disabled />
            <FormInput id="lastName" label="Last name" disabled />
        </FormLine>
        <FormLine>
            <FormInput id="age" label="Age" disabled />
        </FormLine>
        <FormInput id="email" label="Email" disabled />
        <ProfileToggle />
    </>
);
